import { drawerAnatomy } from '@chakra-ui/anatomy';
import {
  createMultiStyleConfigHelpers,
  cssVar,
} from '@chakra-ui/styled-system';

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(drawerAnatomy.keys);

const $bg = cssVar('drawer-bg');
const $borderColor = cssVar('drawer-border-color');
const $color = cssVar('drawer-color');
const $overlayBg = cssVar('drawer-overlay-bg');

const baseStyle = definePartsStyle(() => ({
  overlay: {
    bg: $overlayBg.reference,
    _dark: {
      [$overlayBg.variable]: 'colors.bg.overlay',
    },
  },
  dialogContainer: {
    // Container for the drawer
  },
  dialog: {
    bg: $bg.reference,
    borderLeft: '1px solid',
    borderColor: $borderColor.reference,
    color: $color.reference,
    height: '100%',
    maxHeight: '100dvh',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 'env(safe-area-inset-bottom, 0px)',
    _dark: {
      [$bg.variable]: 'colors.bg.modal',
      [$borderColor.variable]: 'colors.border.light',
      [$color.variable]: 'colors.fonts.primary',
    },
  },
  header: {
    color: $color.reference,
    borderBottom: '1px solid',
    borderColor: 'border.light',
    paddingX: { base: '4', md: '8' },
    paddingY: 4,
    _dark: {
      [$color.variable]: 'colors.fonts.primary',
    },
  },
  closeButton: {
    // Close button styling - inherits from dialog color
  },
  body: {
    padding: 0,
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    color: $color.reference,
    _dark: {
      [$color.variable]: 'colors.fonts.primary',
    },
  },
  footer: {
    color: $color.reference,
    borderTop: '1px solid',
    borderColor: 'border.light',
    paddingX: { base: 4, md: 8 },
    paddingTop: 4,
    paddingBottom: { base: 4, md: 5 },
    justifyContent: 'flex-start',
    _dark: {
      [$color.variable]: 'colors.fonts.primary',
    },
  },
}));

export const drawerTheme = defineMultiStyleConfig({
  baseStyle,
});
